import React, { Component, Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Shop from "./Shop";
import ShopProduct from "./ShopProduct/ShopProduct";
import ShopCart from "./ShopCart/ShopCart";
import ShopValidation from "./ShopValidation/ShopValidation";
import { SentryRoute } from "index";

class ShopRouter extends Component {
  render() {
    const { match, location } = this.props;
    return (
      <Fragment>
        <Switch location={location}>
          <SentryRoute exact path={`${match.path}`} component={Shop} />
          <SentryRoute
            exact
            path={`${match.path}/product/:id`}
            component={ShopProduct}
          />
          <SentryRoute exact path={`${match.path}/cart`} component={ShopCart} />
          <SentryRoute
            exact
            path={`${match.path}/cart/order=:number`}
            component={ShopValidation}
          />
          <SentryRoute component={Shop} />
        </Switch>
      </Fragment>
    );
  }
}

export default withTranslation()(ShopRouter);
